module.exports = __webpack_public_path__ + "static/media/patter1.72a8c508.png";